import { ca } from '@cian/analytics';

export function trackRulerClick(objectType?: string) {
  ca('eventSite', {
    action: 'click_show_sopr',
    category: 'Infrastructure',
    label: 'ruler',
    name: 'oldevent',
    page: {
      pageType: 'CardJK',
      siteType: 'desktop',
      extra: {
        PageTypeJK: 'Featuring',
        object_type: objectType,
      },
    },
    useLastProducts: true,
  });
}
